import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const ThemesPage = lazy(() => import('./pages/ThemesPage'));

export const ThemesRoutes: RouteObject = {
  path: 'themes',
  children: [
    { path: '', element: <ThemesPage />, handle: { crumb: 'Themes & Brand System' } },
  ],
};
